import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ReissuePassword from './pages/ReissuePassword';

import urls, { reissuePasswordUrl } from './urls';


const ReissuePasswordRoute = () => {
  return (
    <Switch>
      <Route exact path={reissuePasswordUrl()} component={ReissuePassword} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default ReissuePasswordRoute;
